import { render, staticRenderFns } from "./add-training-courses.vue?vue&type=template&id=cb971090"
import script from "./add-training-courses.vue?vue&type=script&lang=js"
export * from "./add-training-courses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports